import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useMemorialStore } from '../stores/memorial'

// Entry points into the memorial creation flow, shared by the landing page and the guides CTAs
export function useStartMemorial() {
  const router = useRouter()
  const store = useMemorialStore()

  const isLoggedIn = computed(() => !!(store.apiToken && store.isAccountCreated && store.isEmailVerified))

  // Signed-out visitor: start from a clean slate
  const startMemorial = () => {
    localStorage.removeItem('api_token')
    localStorage.removeItem('memorial_auth')
    router.push('/who')
  }

  // Signed-in user: keep their account, drop any memory currently loaded
  const startNewMemorial = () => {
    store.clearMemorialData()

    const stored = localStorage.getItem('memorial_auth')
    if (stored) {
      try {
        const data = JSON.parse(stored)
        const cleanData = {
          token: data.token,
          user: data.user,
          isAccountCreated: data.isAccountCreated,
          isEmailVerified: data.isEmailVerified,
          userEmail: data.userEmail
        }
        localStorage.setItem('memorial_auth', JSON.stringify(cleanData))
      } catch (error) {
        console.error('Error clearing memory data:', error)
      }
    }

    router.push('/who')
  }

  const createMemorial = () => (isLoggedIn.value ? startNewMemorial() : startMemorial())

  return { isLoggedIn, startMemorial, startNewMemorial, createMemorial }
}
